import TableSkeleton from '../../../components/loaders/TableSkeleton';
import ListHeader from '../../../components/ListHeader';
import { useTranslation } from 'react-i18next';
import CitiesTableContainer from '../../../modules/cities/components/CitiesTableContainer';
import useModuleTableHelpers from '../../../hooks/useModuleTableHelpers';
import Button from '../../../components/buttons/Button';

const Cities = () => {
  const { t } = useTranslation();

  const { apiData, apiDataLoading, paginationEle } = useModuleTableHelpers({
    route: 'admin/cities',
    withBreadcrumb: true,
    // withSearch: true,
    breadcrumbTitle: t('links.cities'),
    withPagination: true,
    queryKey: 'cities'
  });

  const tableHeaders = [
    { label: t('id') },
    { label: t('name') },
    { label: t('actions'), customClass: 'actions_col' }
  ];

  if (apiDataLoading && !apiData) return <TableSkeleton columns={6} withoutButton />;

  return (
    <div className="cities-page-container">
      <ListHeader>
        <div className="filter_container"></div>
        <Button text={t('create_city')} link="/cities/create-city" />
      </ListHeader>
      <CitiesTableContainer tableHeaders={tableHeaders} data={apiData} noDataMessage={t('no_cities_found')} lessColumns />
      {paginationEle}
    </div>
  );
};

export default Cities;
